<template>
  <div id="userForm">
    <div class="col s12 input-field z">
        <input type="text" name="name" id="name" v-model="company['name']">
        <label for="name"><span>Company Name</span></label>
    </div>
    <div class="col s12">
      <small-complete
        list-key="name"
        @update="$_setCountry($event)"
        :list-data="c">
        Country
      </small-complete>
    </div>
    <div class="col s12 input-field z">
      <textarea id="address" v-model="company['address']" class="materialize-textarea"></textarea>
      <label for="address">Address </label>
    </div>
      <div class="col s12 input-field z">
      <textarea id="address_line_2" v-model="company['address_line_2']" class="materialize-textarea"></textarea>
      <label for="address_line_2">Address Line 2</label>
    </div>
    <div class="col s12">
      <button 
      :disabled="gd || valid"
      @click="$_createCompany()" class="btn col s12 blue accent-4 btn-medium waves-effect">Add Company</button>
    </div>
    <div class="col s12">
      <br>
    </div>
  </div>
</template>
<script>
const sortPhunction = arr => {
  return arr.sort(function(a, b) {
    let textA = a.name.toLowerCase();
    let textB = b.name.toLowerCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });
};
import smallComplete from '@/components/records/fields/autoComplete.component'
import core from '@/functions'
import contentService from '@/services/contentService'

export default {
  name:'newCompany',
  props:{
    dataCompanies:{
      type:Array,
    }
  },
  components:{
    smallComplete
  },
  data(){
    return {
      countrySelect: {
        field_type: "inputField",
        v: true,
        type: "select",
        label: "Country",
        values: "",
        name: "country",
        options: sortPhunction(core.countries)
        },
      gd:false,
      company:new Object,
    }
  },
  computed:{    
    valid:{
      get(){
        return false
      },
    },
    c:{
      get(){
        return core.countries
      }
    }
  },
  methods:{
    $_setCountry(evt){
      this.company['country'] = evt.name
    },
    $_createCompany(){
      this.gd = true
      let payload = {
        title:`${this.company.name}`,
        status:'publish',
        fields:{
          name:this.company.name,
          address:this.company.address,
          address_line_2:this.company.address_line_2 ? this.company.address_line_2 : ' ',
          country:this.company.country,
        }
      }
      contentService.saveCompanyRecord(payload)
      .then(res =>{
        this.gd = false
        this.$store.commit('ADD_COMPANY',res.data)
        this.$emit('update',res.data)
        core.toastMessage('New Organization Added')
      })
      .catch(err => {
        core.toastMessage(`Error contact administrator`, ()=>{ window.warn(err)})
      })
    }
  }
}
</script>